import React from 'react';
import {FormElements} from "../../../../shared/ui/form/FormElements";
import {StructureFormModel} from "../../../../shared/ui/form/models/FormModule";
import {formControlTypes} from "../../../../shared/ui/form/models/formControlTypes";
import {useForm} from "../../../../shared/utils/forms/useForm";
import {UseFormSubmitModel} from "../../../../shared/utils/forms/models/UseFormModel";
import {required} from "../../../../shared/utils/forms/utils/validationType";
import BtnRow from "../../../../shared/ui/form/BtnRow";
import http from "../../../../shared/utils/http";
import {useSelector} from "react-redux";
import {selectSelectedPharmacy} from "../../../../core/reducer/pharmacySlice";
import {addErrorMessage} from "../../../../core/errors/errorSlice";
import {useAppDispatch} from "../../../../app/hooks";

const FormAddCloseDay = ({closeFormHandler, successActionHandler}: {
    successActionHandler: (data: any) => void,
    closeFormHandler: () => void
}) => {
    const pharmacy = useSelector(selectSelectedPharmacy)
    const dispatch = useAppDispatch();


    const submitActionHandler: UseFormSubmitModel = (event, data) => {
        const splitDate = (dateString: string) => {
            const date = new Date(dateString)
            return {year: date.getFullYear(), month: date.getMonth(), day: date.getDate()};
        };


        http.post(`pharmacies/${pharmacy?.idDocument}/holidays`, splitDate(data.dayData)).then(res => {
            successActionHandler(res?.holiday)
        }, err => {
            dispatch(addErrorMessage({title: 'Errore nel salvataggio del giorno di chiusura. Riprova più tardi, grazie.'}))
        })

    }
    const validations = [
        {
            name: 'dayData',
            validations: [
                {
                    name: required,
                    params: {name: "Giorno"},
                },
            ],
        },
    ]

    const structureDataCloseDay: StructureFormModel[] = [
        {
            type: formControlTypes.input,
            name: "dayData",
            label: "Giorno",
            dataElement: {
                placeholder: "Inserisci giorno",
                type: 'date',
            },
            display: {form: 'row', label: 'col-4', child: 'col-8'},
            col: {xs: "12"},
        },
    ]

    const {
        dataFormatted,
        dataForm,
        setData,
        errors,
        isSubmit,
        changeValue,
        submitAction
    } = useForm(submitActionHandler, validations)


    return (
        <div>
            <div className={'form-container'}>
                <FormElements structure={structureDataCloseDay} changeValue={changeValue} dataForm={dataForm}
                              errors={errors} isSubmit={isSubmit}/>
            </div>
            <BtnRow submitAction={submitAction} closeFormHandler={closeFormHandler}/>
        </div>
    );
};

export default FormAddCloseDay;
